import { render, staticRenderFns } from "./SP360Card.vue?vue&type=template&id=55d65057&scoped=true&"
import script from "./SP360Card.vue?vue&type=script&lang=js&"
export * from "./SP360Card.vue?vue&type=script&lang=js&"
import style0 from "./SP360Card.vue?vue&type=style&index=0&id=55d65057&lang=scss&scoped=true&"
import style1 from "./SP360Card.vue?vue&type=style&index=1&id=55d65057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d65057",
  null
  
)

export default component.exports